exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal button.delete{height:30px;max-height:30px;max-width:30px;min-height:30px;min-width:30px;width:30px\n}\n.modal .media-content{padding:2em 1em\n}", ""]);

// exports
